import { AssessmentTypeEnum } from '@ztechapps/quickscore.contract'

/**
 * Single source of truth for the `AppSetting.key` values QuickScore's admin-configurable scan
 * model routing reads and writes — shared by both runtimes (api, worker), the admin app, the
 * seed migration and the api-test seed import, so none of them can drift on the literal. Keyed
 * by `AssessmentTypeEnum` so callers do one lookup instead of re-deriving bubble-vs-handwritten
 * branching at each call site.
 */
export const quickscoreAppSettingsKey: Record<AssessmentTypeEnum, string> = {
  [AssessmentTypeEnum.Bubble]: 'QUICKSCORE_BUBBLE_SCAN_MODEL',
  [AssessmentTypeEnum.Handwritten]: 'QUICKSCORE_HANDWRITTEN_SCAN_MODEL',
}
